module.exports = __webpack_public_path__ + "img/logo-m2n.66640b17.svg";